import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as content from '../../content'

/** TODO:  */
@ngCore.Component({
  imports: [
    content.boolean.Component,
    content.date.Component,
    content.dateRange.Component,
    content.list.Component,
    content.number.Component,
    content.standard.Component,
  ],
  selector: 'atn-intrinsic-switcher',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ents.core.common.value.Raw} */
  public readonly valueSg = ngCore.input.required<ents.core.common.value.Raw>({
    alias: 'value',
  })

  /** TODO: */
  public readonly valueInfoSg = ngCore.input<
    ents.core.common.value.Info | undefined
  >(undefined, { alias: 'valueInfo' })

  /** TODO:  */
  public readonly typeSg = ngCore.computed<
    ents.core.common.value.types.Intrinsic | undefined
  >((valueInfo = this.valueInfoSg(), value = this.valueSg()) => {
    // if type doesn't exist or is not intrinsic type try inferring it
    if (
      !valueInfo?.type ||
      !ents.core.common.value.types.Intrinsic.isIntrinsic(valueInfo.type)
    ) {
      return ents.core.common.value.types.Intrinsic.inferFrom(value)
    }

    return valueInfo.type
  })

  /**
   * If type of value is {@link ents.core.common.value.types.Intrinsic.List Intrinsic.List}, cast value to list and return,
   * otherwise return undefined. Used to determine type of value in template
   */
  public listValueSg = ngCore.computed(
    (value = this.valueSg(), type = this.typeSg()) =>
      type === ents.core.common.value.types.Intrinsic.List
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.List,
          )
        : undefined,
  )

  /**
   * If type of value is {@link ents.core.common.value.types.Intrinsic.DateRange Intrinsic.DateRange}, cast value to list and return,
   * otherwise return undefined. Used to determine type of value in template
   */
  public dateRangeValueSg = ngCore.computed(
    (value = this.valueSg(), type = this.typeSg()) =>
      type === ents.core.common.value.types.Intrinsic.DateRange
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.DateRange,
          )
        : undefined,
  )
  /**
   * If type of value is {@link ents.core.common.value.types.Intrinsic.DateMultirange Intrinsic.DateMultirange}, cast value to list and return,
   * otherwise return undefined. Used to determine type of value in template
   */
  public dateMultirangeValueSg = ngCore.computed(
    (value = this.valueSg(), type = this.typeSg()) =>
      type === ents.core.common.value.types.Intrinsic.DateMultirange
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.DateMultirange,
          )
        : undefined,
  )

  /**
   * If type of value is {@link ents.core.common.value.types.Intrinsic.Date Intrinsic.Date}, cast value to date and return,
   * otherwise return undefined. Used to determine type of value in template
   */
  public dateValueSg = ngCore.computed(
    (value = this.valueSg(), type = this.typeSg()) =>
      type === ents.core.common.value.types.Intrinsic.Date
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.Date,
          )
        : undefined,
  )

  /**
   * If type of value is {@link ents.core.common.value.types.Intrinsic.Boolean Intrinsic.Boolean}, cast value to list and return,
   * otherwise return undefined. Used to determine type of value in template
   */
  public booleanValueSg = ngCore.computed(
    (value = this.valueSg(), type = this.typeSg()) =>
      type === ents.core.common.value.types.Intrinsic.Boolean
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.Boolean,
          )
        : undefined,
  )

  /**
   * Exposing Intrinsic enum to template
   */
  public readonly IntrinsicEnum = ents.core.common.value.types.Intrinsic
}
